<app-title-header [title]="'title.problem_records.title' | translate">
  <div class="actions-container">

    <app-global-search></app-global-search>

    <button type="button" class="create-btn" [routerLink]="[ '/new-problem-record' ]">
      <div>{{ 'buttons.new_problem_records' | translate }} </div>
    </button>
  </div>
</app-title-header>

<div class="grid-container">
  @for (card of cardsList; track card) {
    <app-statistic-card
      class="card-component"
      [value]="card.value"
      [description]="card.description"
      [iconClass]="card.iconClass"
      [color]="card.color"
      [type]="card.type"
      [ngClass]="{'active-card': problemRecordsDataTableState.tableType === card.type}"
      (activeTypeEvent)="getActiveType($event)"
    ></app-statistic-card>
  }
</div>

<app-dynamic-table
  *ngIf="isDataTableReady"
  [tableSizeClass]="'problem-records-page-table'"
  [columns]="columns"
  [rows]="problemRecords"
  [useExternalApi]="true"
  [totalCount]="totalCount"
  [dataTableState]="problemRecordsDataTableState"
  [showSaveDatatableFilterBtn]="true"
  [gridSettingsChanged]="!!problemRecordsDatatableStateFromStorage"
  [defaultColumns]="defaultColumns"
  [selectedFilterName]="selectedFilterName"
  [datatableDisplayAllNames]="datatableDisplayAllNames"
  [showColumnsSettingsBtn]="true"
  [showExportDataBtn]="true"
  [exportDataApiPath]="'/v1/export/grid'"
  [filters]="filters"
  (dataTableStateEvent)="getDataTableState($event)"
  (linkedValueClickEvent)="getLinkedValue($event)"
  (saveDataTableSettingsEvent)="onSaveDatatableSettings($event)"
  (updateDataTableSettingsEvent)="onUpdateDatatableSettings($event)"
></app-dynamic-table>
